var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"journal-lpo"},[_c('journal-toolbar'),_c('div',{staticClass:"table-container"},[_c('journal-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }